/** Single Tauri → Vue bus for native menu accelerators / items. */

import type { UnlistenFn } from "@tauri-apps/api/event";
import { getCurrentWebviewWindow } from "@tauri-apps/api/webviewWindow";

export const MENU_COMMAND_EVENT = "menu-command";

export type MenuCommandPayload = {
  /** Menu item id from Rust (`file-save`, `view-zoom-in`, …). */
  id: string;
};

/**
 * Listen for `menu-command` and dispatch by id. Unknown ids are ignored so
 * App (zoom) and EditorShell (editor actions) can share the same event.
 * The listener is scoped to this window, so a command Rust sends to the
 * focused window does not also run in every other open window.
 */
export async function listenMenuCommands(
  handlers: Record<string, () => void>,
): Promise<UnlistenFn> {
  return getCurrentWebviewWindow().listen<MenuCommandPayload>(
    MENU_COMMAND_EVENT,
    (event) => {
      const id = event.payload?.id;
      if (id === null || id.length === 0) return;
      handlers[id]?.();
    },
  );
}
